if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        // TWD COUNT REVIEW - 2026-09-06: never append an old filter page to a new grid.
        loadedPageUrls: new Set(),
        async loadData(url) {
          const requestUrl = new URL(url, window.location.href).href;
          if (this.loading || this.loadedPageUrls.has(requestUrl)) return;
          const originalTarget = document.getElementById('blog-grid') || document.getElementById('items-grid');
          const originalLocation = window.location.pathname + window.location.search;
          this.loading = true;
          try {
            const response = await fetch(requestUrl, { credentials: 'same-origin' });
            if (!response.ok) throw new Error(`Pagination request failed: ${response.status}`);
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const productGrid = html.getElementById('items-grid');
            if (!productGrid) return;
            const newProducts = Array.from(productGrid.querySelectorAll(':scope > .grid-item'));
            const target = document.getElementById('blog-grid') || document.getElementById('items-grid');
            if (!target || target !== originalTarget || originalLocation !== window.location.pathname + window.location.search) return;

            // TWD SEPARATE-COLOR PAGINATION PERFORMANCE FIX - 2026-09-06
            // A Shopify product can render several color cards. The theme's original
            // 300ms delay per .grid-item becomes very slow when one server page contains
            // many color cards. Batch-append only separate-color collection results.
            const isSeparateColorResult = newProducts.some(
              (item) => item.dataset.colorVariantCard === 'true'
            );

            if (isSeparateColorResult) {
              const fragment = document.createDocumentFragment();
              for (const item of newProducts) {
                item.classList.add('x-pagination-slide-up');
                fragment.appendChild(item);
              }
              target.appendChild(fragment);
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  newProducts.forEach((item) => item.classList.add('x-pagination-slide-up--in'));
                });
              });
            } else {
              for (let i = 0; i < newProducts.length; i++) {
                if (i > 0) await new Promise(r => setTimeout(r, 300));
                if (target !== document.getElementById('items-grid') && target !== document.getElementById('blog-grid')) return;
                if (originalLocation !== window.location.pathname + window.location.search) return;
                const item = newProducts[i];
                item.classList.add('x-pagination-slide-up');
                target.appendChild(item);
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => item.classList.add('x-pagination-slide-up--in'));
                });
              }
            }
            this.loadedPageUrls.add(requestUrl);
            this._renderButton(html);
            requestAnimationFrame(() => window.twdSyncSeparateColorDisplayCounts?.());
          } catch (e) {
            console.error(e);
          } finally {
            this.loading = false;
          }
        },
        _renderButton(html) {
          const destination = document.getElementById(`btn-pagination-${sectionId}`);
          const source = html.getElementById(`btn-pagination-${sectionId}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}